import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./BusinessViewAll.css";
import locationnew from '../../../assets/images/icons/locationnew.svg'
import Breadcremb from '../../../components/BreadCremb';
import i18next from 'i18next';


class BusinessSearchPage extends Component {
    state = { businesses: [], loading: true };

    componentDidMount() {
        this.fetchData(); // Fetch data when the component first mounts
    }

    componentDidUpdate(prevProps) {
        // Re-fetch data if the search query or type changes
        if (this.props.location.search !== prevProps.location.search) {
            this.fetchData();
        }
    }

    fetchData = () => {
        const queryParams = new URLSearchParams(this.props.location.search);
        const query = queryParams.get("query");
        const type = queryParams.get("type");

        this.setState({ loading: true });

        fetch(`${process.env.REACT_APP_BASE_URL}/web/api/v1/search?query=${query}&type=${type}`)
            .then((response) => response.json())
            .then((data) => {
                this.setState({ businesses: data.businesses, loading: false });
            })
            .catch((err) => {
                console.error("Error fetching data:", err);
                this.setState({ loading: false });
            });
    };

    render() {
        const { businesses, loading } = this.state;

        // if (loading) {
        //     return <div>Loading...</div>;
        // }

        // if (businesses.length === 0) {
        //     return <div>No businesses available</div>;
        // }

        return (
            <div className="container">
                <div className='breadcrumbs_Div'>
                    <div>
                        <Breadcremb flag="others" bredcrumb1_link="/tasker" bredcrumb1="Home" bredcrumb2="Details Page" />
                        <h1>{i18next.t('Business For Sale')}</h1>

                    </div>
                </div>
                <div className="business-grid">
                    {businesses.map((business, index) => (
                        index < 20 && (
                            <div key={business.bookingId} className="business-item">
                                <Link to={`/user/business-view/${business.bookingId}`}>
                                    <div className="business-content mx-1">
                                        <div className="categoryImg">
                                            <img
                                                className="imgBg"
                                                src={`https://emprende.net/public/img/bookings/${business.images[0]}`}
                                                // src={`http://services.hitasoft.in/juan/public/img/bookings/${business.images[0]}`}
                                                alt="Business"
                                                height={135}
                                            />
                                        </div>
                                        <div className='business_wholecontent'>
                                            <div>
                                                <h4 className="category-name" >{business.mainCategory.name}</h4>
                                                <p className="subcategory-name">{business.subCategory.name}</p>
                                            </div>
                                            <h3 className="price">USD {Math.floor(business.new_price)?.toLocaleString('en-US')}</h3>
                                        </div>
                                        <div className='business_location'>
                                            <img src={locationnew} />
                                            <p className="city-name">{business.city}</p>
                                            , <p className="city-name">{business.country}</p>

                                        </div>
                                    </div>
                                </Link>
                            </div>
                        )
                    ))}
                </div>
            </div>
        );
    }
}

export default BusinessSearchPage;
